/** Пока модуль доступен только на портале baysport (бета). */
const ANALYTICS_PRO_ALLOWED_SUBDOMAINS = new Set(["baysport"]);

export const ANALYTICS_PRO_PRICE_RUB = 600;

export function isAnalyticsProAllowed(tenantOrSubdomain) {
  const sub =
    typeof tenantOrSubdomain === "string"
      ? tenantOrSubdomain
      : tenantOrSubdomain?.subdomain;
  return ANALYTICS_PRO_ALLOWED_SUBDOMAINS.has(
    String(sub || "").trim().toLowerCase(),
  );
}

export function formatPriceRub(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("ru-RU")} ₽`;
}

export function isAnalyticsProActive(moduleOrTenant, plan) {
  if (plan?.analyticsPro) return true;
  if (!moduleOrTenant) return false;
  if (moduleOrTenant.active != null) return Boolean(moduleOrTenant.active);
  const until = moduleOrTenant.paid_until || moduleOrTenant.analytics_pro_paid_until;
  if (!until) return false;
  return String(until).slice(0, 10) >= new Date().toISOString().slice(0, 10);
}
